<template>
	<div id="app">
		<a-locale-provider :locale="pt_BR">
			<router-view/>
		</a-locale-provider>
	</div>
</template>

<script>
import PortalCredencialWebApi from "@/API/PortalCredencialWebApi";
import { DO_LOGOUT } from "@/store/actions";
import pt_BR from 'ant-design-vue/lib/locale-provider/pt_BR';
import moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-br');

export default {
  name: "App",
  data() {
    return {
      pt_BR,
    }
  }
};
</script>

<style>
#app {
	font-family: "Avenir", Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	height: 100%;
}
#nav {
	padding: 30px;
}

#nav a {
	font-weight: bold;
	color: #2c3e50;
}

#nav a.router-link-exact-active {
	color: #42b983;
}

.ant-popover-arrow {
	z-index: 9 !important;
	background-color: white !important;
}

.ant-spin-nested-loading > div > .ant-spin {
	margin-top: 10px;
}

.ant-breadcrumb, .ant-menu, .ant-input, .ant-table, .ant-modal, .ant-collapse, .ant-tabs, .ant-select {
	font-family: "Avenir", Helvetica, Arial, sans-serif !important;
}

.ant-input-disabled{
    color: black !important;
}

.ant-select-disabled{
    color: black !important;
}

.ant-divider-horizontal.ant-divider-with-text, .ant-divider-horizontal.ant-divider-with-text-left, .ant-divider-horizontal.ant-divider-with-text-right {
	margin: 5px 0 !important;
}

.ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text, .ant-divider-horizontal.ant-divider-with-text-right .ant-divider-inner-text {
	font-size: 15px !important;
}

.ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text, .ant-divider-horizontal.ant-divider-with-text-right .ant-divider-inner-text {    
    padding: 0 5px 0 0 !important;
}

.ant-divider-horizontal.ant-divider-with-text-left::before {    
    width: 0% !important;
}

.ant-modal-title {
	color: #fff !important;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
}

.ant-modal-close-x {
	color: #fff;
}

.ant-modal-content {
	border-radius: 6px;
}

.ant-table-small {
    border: 1px solid #e8e8e8 !important;
    border-radius: 0px !important;
}

.ant-table-middle {
    border: 1px solid #e8e8e8 !important;
    border-radius: 0px !important;
}

.ant-table-small > .ant-table-content .ant-table-header {
    background-color: #b8c2cc !important;
}

.ant-table-small > .ant-table-content > .ant-table-body {
    margin: 0 0px !important;
}

.ant-menu-submenu-popup {
    width: 195px !important;
}

.ant-upload-list-item:hover .ant-upload-list-item-info {
    background-color: #b3d7f98f !important;
}
</style>